import React from "react";
import CardComponent from "./CardComponent";
import { Box, Grid } from "@mui/material";
import { CardSkeleton } from "./CardSkeleton";
import { AnimatePresence, motion } from "framer-motion";



const CardViewSection = ({ loading,cardData=[] }) => {
  const clickFunction = () => {
    console.log("Card clicked");
  };
  return (
    <AnimatePresence initial={true} mode="wait">
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: "auto", opacity: 1 }}
        exit={{ height: 0, opacity: 0 }}
        transition={{ duration: 1.5, ease: "easeInOut" }}
        style={{ overflow: "hidden" }}
      >
        <Box p={1}>
          <Grid container spacing={3}>
            {loading ? (
              <CardSkeleton />
            ) : (
              cardData.map((card, index) => (
                <Grid item xs={12} sm={6} md={4} xl={4} key={index}>
                  <CardComponent
                    title={card.title}
                    total={card.value}
                    // icon={card.icon} 
                    // color={card.color}
                    clickFunction={clickFunction}
                  />
                </Grid>
              ))
            )}
          </Grid>
        </Box>
      </motion.div>
    </AnimatePresence>
  );
};

export default CardViewSection;
